// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info_info__VqNfG {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.info_info__VqNfG .info_list__KIgQe {\n  display: grid;\n  width: 100%;\n  flex: 1;\n  grid-template-columns: repeat(2, 1fr);\n}\n.info_info__VqNfG .info_unsubscribe__JeTuL {\n  border-top: 1px solid var(--white-20);\n  padding: 20px 0;\n}", ""]);
// Exports
exports.locals = {
	"info": "info_info__VqNfG",
	"list": "info_list__KIgQe",
	"unsubscribe": "info_unsubscribe__JeTuL"
};
module.exports = exports;
